module.exports = __webpack_public_path__ + "static/media/mercearia.dcb05de7.jpg";